module.exports = __webpack_public_path__ + "img/carga.2a9f4179.svg";